var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 9,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1526 16.1601C17.1526 18.8974 14.8944 21.1201 12.0968 21.1201C9.29927 21.1201 7.04102 18.8974 7.04102 16.1601C7.04102 13.4228 9.29927 11.2001 12.0968 11.2001C14.8944 11.2001 17.1526 13.4228 17.1526 16.1601ZM22.6915 16.1601C22.6915 18.7331 21.5568 20.8244 20.1636 20.8244C18.7705 20.8244 17.6357 18.7331 17.6357 16.1601C17.6357 13.587 18.7705 11.4957 20.1636 11.4957C21.5568 11.4957 22.6915 13.5761 22.6915 16.1601ZM24.961 16.1601C24.961 18.4704 24.5678 20.3427 24.0734 20.3427C23.5791 20.3427 23.1859 18.4704 23.1859 16.1601C23.1859 13.8498 23.5791 11.9775 24.0734 11.9775C24.5678 11.9775 24.961 13.8498 24.961 16.1601Z",
    fill: "#B1D287"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.eb94697afb6b81f9e61df1dcc612993d.svg";
export { ForwardRef as ReactComponent };